<div class="row row_flex back_flex">
  <div class="col-md-3 card back_card">
    <span (click)="back()" style="cursor: pointer">
      <mat-icon>keyboard_backspace</mat-icon>
    </span>
  </div>
</div>

<!--Mail Card-->
<div class="card mail-card row_flex">
  <div class="row" style="margin-bottom: 1.938rem">
    <div class="col-md-2">
      <button mat-mini-fab class="person-fab align-middle">
        {{ mailDetails?.from.charAt(0) }}
      </button>
    </div>
    <div class="col-md-7" style="margin-top: 0.7rem">
      <span class="MM24 font-weight-bold">
        {{ mailDetails?.from.split("<")[0] }} </span
      ><!--data.mailData.name-->
    </div>
    <div class="col-md-3" style="margin-top: 0.7rem">
      <span class="MM14">
        {{ mailDetails?.receivedTime | date: "HH:mm" }}
      </span>
    </div>
  </div>
  <div class="row" style="margin-bottom: 1.938rem">
    <div class="col-md-12" style="text-align: justify">
      <span class="MM16 font-weight-bold">
        {{ mailDetails?.subject }}
      </span>
    </div>
  </div>
  <div class="row" style="margin-bottom: 1.938rem">
    <div class="col-md-12" style="text-align: justify">
      <span class="MM16">
        {{ mailDetails?.conent }}
      </span>
    </div>
  </div>
  <div
    class="row"
    *ngFor="let mailDoc of mailDetails?.attechments"
    style="margin-bottom: 1.938rem"
  >
    <div class="col-md-2">
      <mat-checkbox
        style="margin-top: 0.7rem"
        [checked]="mailDoc?.isChecked"
        (change)="selectDocument(mailDoc)"
      ></mat-checkbox>
    </div>
    <div class="col-md-10">
      <div class="card document_card" (click)="downloadAttachment(mailDoc)">
        <div class="row">
          <div class="col-md-2">
            <span class="align-middle">
              <img
                *ngIf="mailDoc?.name.split('.').pop().toLowerCase() === 'pdf'"
                src="../../../../assets/icons/Shared/doc.png"
              />
              <img
                *ngIf="
                  mailDoc?.name.split('.').pop().toLowerCase() === 'xls' ||
                  mailDoc?.name.split('.').pop().toLowerCase() === 'xlsx'
                "
                src="../../../../assets/icons/Shared/xls.png"
              />
            </span>
          </div>
          <div class="col-md-8">
            <span class="MM18 font-weight-bold align-middle doc_preview">{{
              mailDoc?.name
            }}</span>
          </div>
          <div class="col-md-2 pl-0">
            <span class="align-middle"><mat-icon>get_app</mat-icon></span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Action Btns-->
  <div class="row">
    <div class="col-md-12 mb-3">
      <button
        mat-raised-button
        (click)="checkMode('attachMail')"
        *ngIf="allowActions"
        class="save_primary example_full_width"
      >
        Attach Email to Claim
      </button>
    </div>
    <div
      class="col-md-12 mb-3"
      *ngIf="
        allowActions &&
        claimDetails?.isUnRegisteredFlow &&
        (claimDetails.claimStatus === 'PRE_AUTH_SUBMITTED' ||
          claimDetails.claimStatus === 'PRE_AUTH_QUERY_RESPONDED')
      "
    >
      <button
        mat-raised-button
        (click)="attachTPAEmail('PRE_AUTH_UNDER_QUERY')"
        class="save_primary example_full_width"
      >
        Pre Auth Under Query
      </button>
    </div>
    <div
      class="col-md-12 mb-3"
      *ngIf="
        allowActions &&
        claimDetails?.isUnRegisteredFlow &&
        (claimDetails.claimStatus === 'PRE_AUTH_SUBMITTED' ||
          claimDetails.claimStatus === 'PRE_AUTH_QUERY_RESPONDED')
      "
    >
      <button
        mat-raised-button
        (click)="attachTPAEmail('PRE_APPROVAL_RECEIVED')"
        class="save_primary example_full_width"
      >
        Pre Approval Received
      </button>
    </div>
    <div
      class="col-md-12 mb-3"
      *ngIf="
        allowActions &&
        claimDetails?.isUnRegisteredFlow &&
        (claimDetails.claimStatus === 'PRE_AUTH_SUBMITTED' ||
          claimDetails.claimStatus === 'PRE_AUTH_QUERY_RESPONDED' ||
          claimDetails.claimStatus === 'ENHANCEMENT_SUBMITTED' ||
          claimDetails.claimStatus === 'ENHANCEMENT_QUERY_RESPONDED')
      "
    >
      <button
        mat-raised-button
        (click)="attachTPAEmail('REJECT')"
        class="save_primary example_full_width"
      >
        Reject
      </button>
    </div>
    <div
      class="col-md-12 mb-3"
      *ngIf="
        allowActions &&
        claimDetails?.isUnRegisteredFlow &&
        (claimDetails.claimStatus === 'ENHANCEMENT_SUBMITTED' ||
          claimDetails.claimStatus === 'ENHANCEMENT_QUERY_RESPONDED')
      "
    >
      <button
        mat-raised-button
        (click)="attachTPAEmail('ENHANCEMENT_UNDER_QUERY')"
        class="save_primary example_full_width"
      >
        Enhancement Under Query
      </button>
    </div>
    <div
      class="col-md-12 mb-3"
      *ngIf="
        allowActions &&
        claimDetails?.isUnRegisteredFlow &&
        (claimDetails.claimStatus === 'ENHANCEMENT_SUBMITTED' ||
          claimDetails.claimStatus === 'ENHANCEMENT_QUERY_RESPONDED')
      "
    >
      <button
        mat-raised-button
        (click)="attachTPAEmail('ENHANCEMENT_APPROVAL_RECEIVED')"
        class="save_primary example_full_width"
      >
        Enhancement Approval Recieved
      </button>
    </div>
    <div
      class="col-md-12 mb-3"
      *ngIf="
        allowActions &&
        claimDetails?.isUnRegisteredFlow &&
        (claimDetails.claimStatus === 'FINAL_BILLS_SUBMITTED' ||
          claimDetails.claimStatus === 'FINAL_BILLS_QUERY_RESPONDED')
      "
    >
      <button
        mat-raised-button
        (click)="attachTPAEmail('FINAL_BILLS_UNDER_QUERY')"
        class="save_primary example_full_width"
      >
        Query
      </button>
    </div>
    <div
      class="col-md-12 mb-3"
      *ngIf="
        allowActions &&
        claimDetails?.isUnRegisteredFlow &&
        (claimDetails.claimStatus === 'FINAL_BILLS_SUBMITTED' ||
          claimDetails.claimStatus === 'FINAL_BILLS_QUERY_RESPONDED')
      "
    >
      <button
        mat-raised-button
        (click)="attachTPAEmail('APPROVE')"
        class="save_primary example_full_width"
      >
        Approve
      </button>
    </div>
    <div
      class="col-md-12 mb-3"
      *ngIf="
        allowActions &&
        claimDetails?.isUnRegisteredFlow &&
        (claimDetails.claimStatus === 'FILE_SUBMITTED_QUERY_RESPONDED' ||
          claimDetails.claimStatus === 'SCANNED_FILE_RECEIVED' ||
          claimDetails.claimStatus === 'PARTIALLY_SETTLED')
      "
    >
      <button
        mat-raised-button
        (click)="attachTPAEmail('SETTLED')"
        class="save_primary example_full_width"
      >
        Settle
      </button>
    </div>
    <div
      class="col-md-12 mb-3"
      *ngIf="
        allowActions &&
        claimDetails?.isUnRegisteredFlow &&
        (claimDetails.claimStatus === 'FILE_SUBMITTED_QUERY_RESPONDED' ||
          claimDetails.claimStatus === 'SCANNED_FILE_RECEIVED')
      "
    >
      <button
        mat-raised-button
        (click)="attachTPAEmail('FILE_SUBMITTED_UNDER_QUERY')"
        class="save_primary example_full_width"
      >
        Query
      </button>
    </div>
    <div
      class="col-md-12 mb-3"
      *ngIf="
        allowActions &&
        claimDetails?.isUnRegisteredFlow &&
        (claimDetails.claimStatus === 'FILE_SUBMITTED_QUERY_RESPONDED' ||
          claimDetails.claimStatus === 'SCANNED_FILE_RECEIVED')
      "
    >
      <button
        mat-raised-button
        (click)="attachTPAEmail('REJECT')"
        class="save_primary example_full_width"
      >
        Reject
      </button>
    </div>
    <div class="col-md-12">
      <button
        mat-raised-button
        *ngIf="allowActions"
        (click)="checkMode('attachDoc')"
        class="save_secondary example_full_width"
      >
        Attach Documents to Claim
      </button>
    </div>
  </div>
</div>
